export default __webpack_public_path__ + "static/media/card1.4f1c8e3f.png";